export default "__VITE_ASSET__8xyA5NVd__"